'use strict';

Page.Bsp = new Class({
	Extends: Page,
	build: function build() {
		this.parent();

		this.building_stalker_data();
		this.fill_nav_title();
		this.add_save_link();
		this.add_share_link();
		this.add_alert_link();
	},
	building_stalker_data: function building_stalker_data() {
		var _info = document.getElement('.stalker_info');
		var building_stalker = document.getElement('.persist_nav.building');
		var building_name = _info.getElement('input[name="build_name"]').value;
		var building_address = _info.getElement('input[name="build_address"]').value;

		// Doorman?
		var is_doorman = _info.getElement('input[name="is_doorman"]').value;

		// Sales history removal
		var is_sales_history = _info.getElement('input[name="is_sales_history"]').value;
		if (!is_sales_history) {
			building_stalker.getElement('.sale-history').remove();
		}

		// Ratings removal
		var is_ratings = _info.getElement('input[name="is_ratings"]').value;
		if (!is_ratings) {
			building_stalker.getElement('.ratings').remove();
		}

		var build_type = _info.getElement('input[name=build_type]').value.capitalize();
		var build_hood = _info.getElement('input[name=map_name]').value;
		if (building_name) {
			building_stalker.getElement('.title').set('text', building_name + ', ' + building_address);
		} else {
			building_stalker.getElement('.title').set('text', building_address);
		}
		building_stalker.getElement('.bldg-type').set('text', (is_doorman ? 'Doorman ' : '') + build_type + ' in ' + build_hood);
	},

	fill_nav_title: function fill_nav_title() {
		var _stalker_title = document.getElement('.w_stalker .nav_title');

		var building_stalker = document.getElement('.persist_nav.building');
		var _info = document.getElement('.stalker_info');
		var is_doorman = _info.getElement('input[name="is_doorman"]').value;
		var build_type = _info.getElement('input[name=build_type]').value.capitalize();
		var build_hood = _info.getElement('input[name=map_name]').value;
		building_stalker.getElement('.bldg-type').set('text', (is_doorman ? 'Doorman ' : '') + build_type + ' in ' + build_hood);

		// links
		var navItems = document.querySelectorAll('.building_nav ul li');
		var bldgFullUrl = document.querySelector('input[name="bldg_full_url"]').value;

		navItems.forEach(function (item) {
			item.addEventListener('click', function () {
				var targetId = this.getAttribute('data-target');
				if (targetId) {
					var fullUrlWithHash = bldgFullUrl + '#' + targetId;
					// redirect to hash
					window.location.href = fullUrlWithHash;
				}
			});
		});

		if (!_stalker_title) {
			return;
		}

		// var _stalker_info = _stalker_title.getElement('._info');
		// var _stalker_build_type = _stalker_title.getElement('._type');

		// let buildingTypeAndHood;
		// if (this.build_type != '' ) {
		// 	buildingTypeAndHood = this.build_type;
		// }
		// if (this.map_name != '') {
		// 	if (this.build_type != '' ) {
		// 		buildingTypeAndHood += ' in ';
		// 	}
		// 	buildingTypeAndHood += this.map_name;
		// }
		// _stalker_build_type.set('text', buildingTypeAndHood);
	},

	add_alert_link: function add_alert_link() {
		var _alertButton = document.getElement('.alert-button-container .building-alert');
		this._stalker_alert_link = document.getElement('.w_stalker .persist_nav.building .links-icons');
		if (this._stalker_alert_link && _alertButton) {
			_alertButton.inject(this._stalker_alert_link);
		}
	},
	add_save_link: function add_save_link() {
		var _alertButton = document.querySelector('.alert-button-container .building-alert2');
		this._stalker_alert_link = document.querySelector('.w_stalker .persist_nav.building .other-icons');
		if (this._stalker_alert_link && _alertButton) {
			var clonedAlertButton = _alertButton.cloneNode(true);
			this._stalker_alert_link.appendChild(clonedAlertButton);
		}
	},

	add_share_link: function add_share_link() {
		var _shareButton = document.querySelector('.alert-button-container .link-icon.email');
		this._stalker_alert_link = document.querySelector('.w_stalker .persist_nav.building .other-icons');
		if (this._stalker_alert_link && _shareButton) {
			var clonedShareButton = _shareButton.cloneNode(true);
			this._stalker_alert_link.appendChild(clonedShareButton);
		}
	}
});
//# sourceMappingURL=bsp.js.map
